var React = require('react');

function VideoControlsUnmuteInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"21.9305","y":"4","width":"1.47752","height":"23.9433","transform":"rotate(45 21.9305 4)","fill":"currentColor","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.1477 6.77247V3L11.2603 7.82574H6.00024V16.2225H7.69765L17.1477 6.77247ZM12.765 17.4436L17.1477 21V13.0609L12.765 17.4436Z","fill":"currentColor","key":1})]);
}

VideoControlsUnmuteInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = VideoControlsUnmuteInline;

VideoControlsUnmuteInline.default = VideoControlsUnmuteInline;
